const translation = {
  nav: {
    home: "Strona główna",
    spreadsheet: "Spreadsheet",
    categories: "Kategorie",
    guides: "Poradniki",
    safety: "Bezpieczeństwo",
    faq: "FAQ",
    shoppingGuide: "Poradnik zakupowy",
    navigation: "Nawigacja",
    categoryLinks: "Kategorie produktów",
  },
  hero: {
    h1: "Kakobuy Spreadsheet Polska",
    h2: "Najlepsza baza produktów, linków i okazji 2026",
    subtitle: "Znajdź tysiące produktów z Taobao, Weidian oraz 1688 w jednym miejscu. Nasz Kakobuy Spreadsheet pomaga szybciej odkrywać najlepsze sneakersy, streetwear, ubrania i akcesoria.",
    ctaMain: "Przeglądaj Kakobuy Spreadsheet",
    ctaSecondary: "Kup teraz",
  },
  trust: {
    title: "Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?",
    cards: [
      {
        title: "Aktualne listy produktów",
        desc: "Regularnie aktualizowane zestawienia najlepszych produktów z wszystkich kategorii.",
      },
      {
        title: "Kategorie produktów",
        desc: "Sneakersy, ubrania, bluzy, kurtki, torby i wiele więcej w jednym arkuszu.",
      },
      {
        title: "Poradniki zakupowe",
        desc: "Instrukcje krok po kroku dla początkujących użytkowników platformy Kakobuy.",
      },
      {
        title: "Bezpieczne zakupy",
        desc: "Informacje dotyczące kontroli jakości, sprawdzonych sprzedawców i bezpiecznej wysyłki.",
      },
    ],
  },
  categories: {
    title: "Przeglądaj kategorie produktów",
    subtitle: "Wybierz kategorię, aby zobaczyć najlepsze produkty w naszym arkuszu Kakobuy Spreadsheet",
    dropdownLabel: "Wybierz kategorię",
    dropdownPlaceholder: "Kliknij, aby wybrać kategorię...",
  },
  spreadsheet: {
    title: "Najnowszy Kakobuy Spreadsheet",
    subtitle: "Aktualne zestawienie najlepszych produktów — ceny, kategorie i oceny w jednym miejscu.",
    tableHeaders: ["Produkt", "Kategoria", "Cena", "Ocena"],
    viewFullList: "Zobacz pełną listę",
  },
  comparison: {
    title: "Dlaczego Kakobuy Spreadsheet jest lepszy?",
    headers: ["", "Kakobuy Spreadsheet", "Ręczne szukanie"],
    rows: [
      { label: "Czas", spreadsheet: "★★★★★", manual: "★★" },
      { label: "Kategorie", spreadsheet: "Tak", manual: "Nie" },
      { label: "Gotowe linki", spreadsheet: "Tak", manual: "Nie" },
      { label: "Porównanie produktów", spreadsheet: "Tak", manual: "Nie" },
      { label: "Aktualizacje", spreadsheet: "Tak", manual: "Nie" },
    ],
  },
  safety: {
    title: "Czy Kakobuy jest bezpieczny?",
    content: "Bezpieczeństwo zakupów online jest dla nas priorytetem. Stworzyliśmy kompletny przewodnik obejmujący wszystkie aspekty bezpiecznego korzystania z platformy Kakobuy — od weryfikacji sprzedawców przez kontrolę jakości produktów aż po bezpieczne metody płatności i śledzenie przesyłek. Zapoznaj się z naszym szczegółowym poradnikiem, aby dokonywać zakupów z pełnym spokojem.",
    cta: "Przeczytaj przewodnik bezpieczeństwa",
  },
  content: {
    title: "Kakobuy Spreadsheet — Twój klucz do najlepszych okazji",
    paragraph1: "Kakobuy Spreadsheet to kompleksowe narzędzie stworzone z myślą o polskich klientach poszukujących wyjątkowych produktów z chińskich platform zakupowych. Nasz arkusz zawiera starannie wyselekcjonowane produkty, które przeszły wieloetapową weryfikację pod kątem jakości wykonania, wiarygodności sprzedawcy oraz atrakcyjności cenowej.",
    paragraph2: "W przeciwieństwie do standardowego przeglądania platform takich jak Taobao czy Weidian, Kakobuy Spreadsheet eliminuje godziny żmudnego wyszukiwania. Każdy produkt w naszym arkuszu posiada bezpośredni link do zakupu, aktualną cenę oraz informacje o dostępnych wariantach. To oszczędność czasu, pieniędzy i nerwów — wszystko czego potrzebujesz, zamknięte w jednym przejrzystym dokumencie.",
    paragraph3: "Nasz zespół codziennie monitoruje trendy w modzie streetwearowej i sneakerowej, aby dostarczać Ci wyłącznie aktualne i wartościowe znaleziska. Niezależnie od tego, czy szukasz limitowanych edycji sneakersów Nike, ekskluzywnych bluz Fear of God, czy designerskich toreb — Kakobuy Spreadsheet ma wszystko, czego potrzebujesz do udanych zakupów.",
    readMore: "Przeczytaj pełny poradnik",
  },
  faq: {
    title: "Najczęściej zadawane pytania",
    questions: [
      {
        q: "Co to jest Kakobuy Spreadsheet?",
        a: "Kakobuy Spreadsheet to uporządkowana lista produktów, która pomaga użytkownikom szybko znaleźć najlepsze okazje z chińskich platform zakupowych. Zawiera bezpośrednie linki, ceny, kategorie i oceny produktów — wszystko w jednym miejscu.",
      },
      {
        q: "Czy Kakobuy Spreadsheet jest darmowy?",
        a: "Tak, nasz podstawowy Kakobuy Spreadsheet jest całkowicie darmowy. Udostępniamy go wszystkim użytkownikom, którzy chcą szybciej i wygodniej odkrywać najlepsze produkty z Taobao, Weidian i 1688.",
      },
      {
        q: "Czy Kakobuy wysyła do Polski?",
        a: "Tak, Kakobuy oferuje wysyłkę do Polski za pośrednictwem różnych metod dostawy. Platforma obsługuje międzynarodowe zamówienia, a proces wysyłki jest w pełni śledzony. Czas dostawy do Polski wynosi zazwyczaj od 10 do 20 dni roboczych.",
      },
      {
        q: "Jak znaleźć najlepsze produkty w Kakobuy?",
        a: "Najlepszym sposobem jest korzystanie z naszego Kakobuy Spreadsheet, który grupuje sprawdzone produkty według kategorii. Arkusz jest regularnie aktualizowany i zawiera wyłącznie produkty od zweryfikowanych sprzedawców z wysokimi ocenami.",
      },
      {
        q: "Czy produkty z Kakobuy Spreadsheet są oryginalne?",
        a: "W naszym arkuszu oznaczamy zarówno produkty oryginalne, jak i repliki wysokiej jakości. Każdy produkt ma jasny opis i kategorię, dzięki czemu dokładnie wiesz, co kupujesz. Zawsze zalecamy sprawdzenie zdjęć QC przed finalizacją zamówienia.",
      },
    ],
  },
  article: {
    cta: "Przeczytaj pełny poradnik Kakobuy Spreadsheet",
  },
  footer: {
    copyright: "© 2026 KakobuyPolska.hair. Wszelkie prawa zastrzeżone.",
    disclaimer: "Ta strona nie jest powiązana z Kakobuy. Jest to niezależny projekt dostarczający informacji i linków do produktów.",
  },
};

export default translation;